import { Component, Story, Knobs } from './DocTypes';

const PlaygroundKnobs: Knobs = {
  name: {
    default: 'exampleName',
    editor: 'textbox',
  },
  colourScheme: {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', 'default', ''],
    default: '',
  },
  disabled: {
    default: false,
    editor: 'checkbox',
  },
  placeholder: {
    default: 'Select a date...',
    editor: 'textbox',
  },
  value: {
    default: '',
    editor: 'textbox',
  },
};

const DateStory: Story = {
  title: 'Date picker',
  description: 'A simple mobile date input element with various attributes',
  coreComponent_v3: {
    html: `<div style="padding: 16px;">
  <tag3-mobile-date-time-input type="date" {{...knobs}} ></tag3-mobile-date-time-input>
</div>`,
    knobs: {
      ...PlaygroundKnobs,
      formattingOptions: {
        default: 'ddd, DD-MMM-YYYY',
        editor: 'textbox',
      },
    },
  },
  reactWrapper_v3: {
    jsx: `<div style={{padding: "16px" }}>
  <TagMobileDateTimeInput type="date" {{...knobs}}></TagMobileDateTimeInput>
</div>`,
    knobs: {
      ...PlaygroundKnobs,
      formattingOptions: {
        default: 'ddd, DD-MMM-YYYY',
        editor: 'textbox',
      },
    },
  },
};

const DateTimeStory: Story = {
  title: 'Datetime picker',
  description: 'A simple mobile datetime input element with various attributes',
  coreComponent_v3: {
    html: `<div style="padding: 16px;">
  <tag3-mobile-date-time-input type="dateTime" {{...knobs}} ></tag3-mobile-date-time-input>
</div>`,
    knobs: {
      ...PlaygroundKnobs,
      formattingOptions: {
        default: 'ddd, DD-MMM-YYYY HH:mm',
        editor: 'textbox',
      },
    },
  },
  reactWrapper_v3: {
    jsx: `<div style={{padding: "16px" }}>
  <TagMobileDateTimeInput type="dateTime" {{...knobs}}></TagMobileDateTimeInput>
</div>`,
    knobs: {
      ...PlaygroundKnobs,
      formattingOptions: {
        default: 'ddd, DD-MMM-YYYY HH:mm',
        editor: 'textbox',
      },
    },
  },
};

const ValidationStory: Story = {
  title: 'With validation',
  description:
    'A simple mobile date input element with various attributes, with required validation enabled',
  coreComponent_v3: {
    html: `<div style="padding: 16px;">
  <tag3-mobile-date-time-input {{...knobs}} ></tag3-mobile-date-time-input>
  <tag3-validator
    source-element="tag3-mobile-date-time-input input"
    source-root-element="tag3-mobile-date-time-input"
    source-element-value-prop="value"
    trigger-element-event="blur"
    rule="required"
    error-element=".entityName-input-error"
  ></tag3-validator>
  <tag3-validation-alert class="entityName-input-error" device="mobile">
      You must choose a value to hide this
  </tag3-validation-alert>
</div>`,
    knobs: {
      ...PlaygroundKnobs,
      formattingOptions: {
        default: 'ddd, DD-MMM-YYYY',
        editor: 'textbox',
      },
    },
  },
  reactWrapper_v3: {
    jsx: `<div style={{padding: "16px" }}>
  <TagMobileDateTimeInput {{...knobs}}></TagMobileDateTimeInput>
  <Tag3Validator 
    sourceElement="tag3-mobile-date-time-input input"
    sourceRootElement="tag3-mobile-date-time-input"
    sourceElementValueProp='value'
    triggerElementEvent='blur'
    rule='required' 
    errorElement='.entityName-input-error' />
  <Tag3ValidationAlert className='entityName-input-error' device="mobile">
    You must choose a value to hide this
  </Tag3ValidationAlert>
</div>`,
    knobs: {
      ...PlaygroundKnobs,
      formattingOptions: {
        default: 'ddd, DD-MMM-YYYY',
        editor: 'textbox',
      },
    },
  },
};

export const TagMobileDateTimeInputDocs: Component = {
  type: 'component',
  name: 'mobile-date-time-input',
  description: 'Renders a mobile date/time input element. This will ONLY work on a mobile device.',
  mobileFriendly: true,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'name',
      description: 'The name of the field',
      type: 'string',
    },
    {
      name: 'type',
      description: 'The input type of the field',
      type: 'date | dateTime',
      default: 'date',
    },
    {
      name: 'inputId',
      description: 'The id of the input field',
      type: 'string',
    },
    {
      name: 'colourScheme',
      description:
        'Dark mode (theme) control. Default for normal browser driven control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light | default',
      default: 'light',
    },
    {
      name: 'disabled',
      description: 'Whether the input selection is disabled or not',
      type: 'boolean',
      default: 'false',
    },
    {
      name: 'formattingOptions',
      description:
        'Additional formatting options for dates. This maps directly to the format parameter in Day.Js see https://day.js.org/docs/en/display/format',
      type: 'string',
      default: '',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'mobileDateTimeInputValueChange',
      description: 'Triggers when the field value changes',
      parameters: [
        {
          name: 'date',
          description: 'The new local date value',
          type: 'string | Date',
        },
        {
          name: 'time',
          description: 'The time component of the date',
          type: 'string',
        },
      ],
    },
  ],
  methods: [],
  stories: [DateStory, DateTimeStory, ValidationStory],
};
